import { z } from 'zod';

/**
 * Quanto dura a sessão do operador no celular, escolhido pelo dono ao criar o
 * operador. A sessão começa quando o celular lê o convite (QR Code); enquanto
 * ela vale, o operador usa o app sem entrar de novo.
 *
 * `null` é "não expira": o celular fica conectado até o dono arquivar ou
 * desativar o operador, trocar a função dele, ou o operador tocar em Sair.
 * Com horas, o prazo conta a partir do convite e não renova com o uso: no
 * fim, o app sai sozinho e o operador precisa de um convite novo.
 */
export const operatorSessionHoursSchema = z.number().int().min(1).max(720).nullable();
export type OperatorSessionHours = z.infer<typeof operatorSessionHoursSchema>;

/** Prazos da lista do painel: um turno, um dia, uma semana, um mês. */
export const OPERATOR_SESSION_HOURS = [8, 12, 24, 168, 720] as const;

/** O prazo que a tela sugere quando o dono escolhe "Expira". */
export const DEFAULT_EXPIRING_SESSION_HOURS = 12;

/** `null` → `Não expira`, `12` → `12 horas`, `168` → `7 dias`. */
export const formatOperatorSessionHours = (hours: OperatorSessionHours): string => {
  if (hours === null) return 'Não expira';
  if (hours >= 48 && hours % 24 === 0) return `${hours / 24} dias`;
  return hours === 1 ? '1 hora' : `${hours} horas`;
};
